"use client";

import React from "react";

interface Option {
  value: string;
  label: string;
}

interface RadioToggleProps {
  name: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  className?: string;
}

const RadioToggle: React.FC<RadioToggleProps> = ({
  name,
  value,
  options,
  onChange,
  className,
}) => {
  return (
    <div
      className={`inline-flex rounded-md border border-gray-300 bg-white p-1 text-sm font-medium text-gray-600 shadow-sm ${className ?? ""}`.trim()}
      role="radiogroup"
      aria-label={name}
    >
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isActive}
            onClick={() => onChange(option.value)}
            className={`min-w-[120px] rounded-md px-3 py-2 transition ${
              isActive
                ? "bg-blue-600 text-white shadow"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default RadioToggle;
